module.exports = __webpack_public_path__ + "static/media/transporter-empty.318ffbb1.svg";